// client.js
import localStorage from 'reactive-localstorage';
import base_url from './base_url';
var pack = require('axios');


var axios = pack.create({
  baseURL: base_url.serverURI,
});

localStorage.on('change', ( key, value ) => {
  if( key === "token" ){
    axios.defaults.headers.common[ "Authorization" ] = value;
  }
})

axios.defaults.headers.common[ "Authorization" ] = window.localStorage.token;

export default axios;
